module.exports = __webpack_public_path__ + "21369185a065fb567bbb795d2e9f2196.png";